import { render, staticRenderFns } from "./StoreApproveMsg.vue?vue&type=template&id=7941ef16"
import script from "./StoreApproveMsg.vue?vue&type=script&lang=js"
export * from "./StoreApproveMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports